import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, delay, Observable, retry, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';
import { InvoicePayment } from '../../../shared/models/invoicePayment.model';
import { Spending } from './../../../shared/models/spending.model';
import { WorkOrderPayment } from './../../../shared/models/worOrderPayment.model';
import { SubjectWorkOrder } from './../../../shared/models/subjectWorkOrder.model';
import { SubjectWorkOrderItem } from './../../../shared/models/subjectWorkOrderItem.model';
import { MyobApiPurchasePaymentSyncToolsWidgetComponent } from './../../../components/myob/myob-api-purchase-payment-sync-tools-widget/myob-api-purchase-payment-sync-tools-widget.component';
import { WorkOrdersGridComponent } from './../../../components/grid/work-orders-grid/work-orders-grid.component';
import { MyobServicePurchase } from './../../../models/myob-service-purchase.model';
@Component({
  selector: 'app-work-order-payment-widget',
  templateUrl: './work-order-payment-widget.component.html',
  styleUrls: ['./work-order-payment-widget.component.css'],
  providers: [MyobApiPurchasePaymentSyncToolsWidgetComponent, WorkOrdersGridComponent]
})
export class WorkOrderPaymentWidgetComponent implements OnInit {

 
  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;

  @Input() invoice_id?; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  @Input() work_order_id?; // impliments on changes.
  @Input() work_order_number?; // impliments on changes.

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
  @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();
  paymentModel: Payment;
  invoicePaymentModel: InvoicePayment;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  invoice_payment: any;

  spendingModel: Spending;
  workOrderPaymentModel: WorkOrderPayment;
  work_order_payment: any;
  work_prder_deleted_data: Object;
  work_order_update_payment_model: any = [];
  work_order_delete_payment_model: any = [];
  modalRef: BsModalRef;
  spending: any;
  current_work_order_id: any;
  current_workOrderUID: any;
  subject_work_order: Object;
  myob_account_codes: Object;
  myob_tax_codes: Object;
  myobSpendingDeletedData: Object;
  myobSpendingListMapped: any;


  work_order_model: SubjectWorkOrder = new SubjectWorkOrder();
  invoice_item_model: any = SubjectInvoiceItem;
  invoiceItemUpdateList: any;
  new_line: {};
  workOrderItemsList: any = SubjectWorkOrderItem;


  @Input() spending_id?; // impliments on changes.

payments: any;
// paymentItemsList: any;
spendingsItemsList: any;
// payment_item_model: any = SubjectInvoiceItem;
spending_item_model: any = SubjectWorkOrderItem;
// myobPaymentCreatedData: any;
// myobPaymentListMapped: any;
myobPaymentDeletedData: Object;
myobSpendingCreatedData: any;
  set_RowVersion: any;
  work_order_deleted_data: Object;


  work_order_item_model: any = SubjectWorkOrderItem;
  data_work_order: any = MyobServicePurchase;

work_orders: any;
myobWorkOrderCreatedData: any;
myobWorkOrderListMapped: any;
myobWorkOrderDeleteData: Object;
myobWorkOrderUpdatedData: any;
invoiceItem: any;
invoiceItemsList: any = SubjectInvoiceItem;
work_orderItemsList: any = SubjectWorkOrderItem;
  myobInvoiceListMapped: any;
  current_spendingUID: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public _MyobApiPurchasePaymentSyncToolsWidgetComponent: MyobApiPurchasePaymentSyncToolsWidgetComponent,
     public _WorkOrdersGridComponent: WorkOrdersGridComponent
  ) {
 
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

 
   }
 
   // check for changes. to load data.
   ngOnChanges(changes) {
 
 
 this.spendingModel = new Spending();  // starts a new empty payment model
 this.workOrderPaymentModel = new WorkOrderPayment();  // starts a new empty payment model
 this.getWorkOrder(this.work_order_id);
 this.getMyobAccountCodes();
 this.getSpendingsByWorkOrderID(this.work_order_id);
 
 this.getWorkOrderPayments(this.work_order_id);


    if (changes.work_order_id) {
      
      // deal with asynchronous Observable result
    //  this.work_order_id = changes.work_order_id.currentValue;
    //  this.getWorkOrder(this.work_order_id);
    //  this.getMyobAccountCodes();
    //  this.getSpendingsByWorkOrderID(this.work_order_id);
 
    }
  }
 
 
  ngOnInit() {
   // this.getInvoice(this.invoice_id);
   // this.getMyobAccountCodes();
  }



  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

  // getInvoice(invoice_id){
  //   this._demoService.getSubjectInvoice(invoice_id).subscribe(
  //     data => {
  //       this.subject_invoice = data;
  //   let res = data[0];
  //   this.current_invoice_id = res.invoice_id;
  //   this.current_invoiceUID = res.UID;
  //      },
  //     err => console.error(err),
  //     // () => console.log('done loading Trace Types')
  //   );
  // }

  getWorkOrder(work_order_id){
    this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
      data => {
        this.subject_work_order = data;
    let res = data[0];
    this.current_work_order_id = res.work_order_id;
    this.current_workOrderUID = res.UID;
       },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // getSubjectWorkOrder(work_order_id){
  //   this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
  //     data => {
  //       this.subject_work_order = data;
  //   let res = data[0];
  //   this.current_work_order_UID = res.UID;
  //   this.current_work_order_UID = res.UID;
  //      },
  //     err => console.error(err),
  //     // () => console.log('done loading Trace Types')
  //   );
  // }


  getInvoicePayments(invoice_id){
    this._demoService.getInvoicePayments(invoice_id).subscribe(
      (data) => {
        this.invoice_payment = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getWorkOrderPayments(work_order_id){
    this._demoService.getWorkOrderPayments(work_order_id).subscribe(
      (data) => {
        this.work_order_payment = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }



// // Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoiceItmes(this.invoice_id);
// }


 refreshSujectInvoicePage(subject_id){
      this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                    this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
    
    }


refreshSujectWorkOrderPage(subject_id){
      this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                    this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));
    
    }



    deletePaymentAndWorkOrderPayment(model) {
      // if (confirm('Are you sure you want to delete this payment entry?')) {
        this._demoService.deletePaymentAndWorkOrderPayment(model)
        .pipe(
          retry(0), // you retry 3 times
          delay(1500) // each retry will start after 1 second,
       )
        .subscribe(
          (data) => {
            this.work_prder_deleted_data = data;
            let res = data[0];
                  // there was a bug here causing the payments to fractture on delete. totals were wrong now fixed 
                  this.work_order_update_payment_model = {
                    work_order_id: model.work_order_id,
                    work_order_payment_total: 0,
                    // work_order_remaining_total: model.work_order_total,
                    work_order_remaining_total: model.spending_total,
                    work_order_status_id: 3, // approved
                    work_order_payment_status_id: 1, // outstanding
                    updated_by: this.gfunc.sessionUserId,
                    updated_date: this.gfunc.today
                  };
          },
          (err) => console.log(err.error),
         () => {
          this.updateWorkOrderAfterPaymentFigures(this.work_order_update_payment_model);
          // this.refreshSujectInvoicePage(this.subject_id);
         }
        );
      // } // end confirm
      }



updateWorkOrderAfterPaymentFigures(model){
        this._demoService.updateWorkOrderAfterPaymentFigures(model).subscribe(
          (data) => {
           // this.new_spending_id = data;
           let res = data[0];
      this.toastr.success('Spending + Invoice Record(s) Applied');
      // :: TOD refresh the invoice modal below.
      // // May need these but was causing a very slow system.
      // this.closeParentModel3.emit();
      // this.closeParentModel2.emit();
      this.gfunc.insertLog_DeletWorkOrderPayment(model);
      this.closeParentModel.emit();
      // this.refreshWorkOrderItemsBelow.emit();
      },
      (err) => console.error(err),
      () => {
        // end of delete
      // refresh/update the payment invoice versions after delete items. (seems to be buggy on delelte.)
  
        console.log('Work Order Model at Del End: ' + JSON.stringify(model));
        // set the ID so the updates of invoice rowvrs can take place
                // this.myobApi_IPTW.getSubjectInvoice(this.current_invoice_id); // runs function in another component before start.
                // this.myobApi_IPTW.subject_id = this.subject_id; // to redirect the page back.
                // this.myobApi_IPTW.getMyobAccountCodes();
                // this.myobApi_IPTW.getMyobAccountCodes();
                // this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS.

      // this.refreshSujectWorkOrderPage(this.subject_id);
      this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
    }
      );
      }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}









// // delete a purchase/bill/service in myob
// deleteMyobServiceWorkOrderModel(model){
//   if (confirm('This will delete this Work Order from Myob, Are you Sure?')) {
// this._demoService.deleteMyobWorkOrder(model).subscribe(
//     data => { this.myobWorkOrderDeleteData = data;
//       const res = data[0];
//       model.myob_id = null;
//       model.sync_with_myob = 0;
//       this.updateSubjectWorkOrder(model);
//         this.refreshGrid();
//       this.toastr.success('Supplier/Agent Invoice Deleted from with Myob');
//     },
//     err => {
//       // this.toastr.error('You need to login to MYOB again, Connection lost!');
//      // console.error(err);
//     },
//     // () => console.log('done loading Trace Types')
//   );

//   }; // end confirm

// };

getSpending(spending_id){
  this._demoService.getSpending(spending_id).subscribe(
    (data) => {
      this.spending = data;
      this.spendingModel = this.spending;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getSpendingsByWorkOrderID(work_order_id){
  this._demoService.getSpendingByWorkOrderID(work_order_id).subscribe(
    (data) => {
      this.spending = data;
      this.spendingModel = this.spending;
      let res = data[0];
      console.log('SpendingModel: ' + JSON.stringify(this.spendingModel));
      // this.current_spendingUID = res.myob_id;
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



// The scrupts in this function wre causing issues. See if this works.
newDeleteAllFunction(model){
  // load the work order Model.
  this.getWorkOrder(model.work_order_id); // so that we have the variable later to upload the row versions
  this._MyobApiPurchasePaymentSyncToolsWidgetComponent.deleteMyobServiceWorkOrderPaymentModel(model);
  this.deletePaymentAndWorkOrderPayment(model); // passed model as normal.
  console.log('time to update row vers: ' + JSON.stringify(model));
  this._WorkOrdersGridComponent.lookupWorkOrderUpdateInvoice(this.current_workOrderUID, model);
}


// Eorrs in getting speindg details of this function below do nut use
getWorkOrderPaymentForDeleteMyobandSop(model){
  if (confirm('Are you sure you want to delete this payment of Spending entry in both myob and sop?')) {
  this._demoService.getSpending(model.spending_id)
  .pipe(
    this.toastr.observe({
      loading: ' ...',
      success: '🚀',
      error: '😡...'
   })
   )
  .pipe(
    retry(5), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 )
  .subscribe(
    (data) => {
      this.spending = data;
      this.spendingModel = this.spending;
      let res = data[0];
        console.log('Deleted Spending/Payment Myob Model ' + JSON.stringify(this.spendingModel));
      // MYOB Live delete payment (Does all the myob stuff from the ToolsComponent.)
      // tslint:disable-next-line:max-line-length
      // SESNDING THEWRON ID 
      this.getWorkOrder(model.work_order_id); // so that we have the variable later to upload the row versions
      this.deleteMyobServiceWorkOrderPaymentModelStep2(res, this.current_workOrderUID); // added invoice ID so that it refreshes the invoice rows after payemnt deleteio
    },
    (err) => console.error(err),
   () => {
          
    
    // then delete from SOP
      // this.deletePaymentAndInvoicePayment(model); // passed model as normal.
      this.deletePaymentAndWorkOrderPayment(model); // passed model as normal.

   }
   );
} // end confirm
}




updateSpending(model){
  this._demoService.updateSpending(model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
  this.toastr.success('Local Payment Datas Updated');
     return true;
    },
    error => {
      console.log(error.error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
    ); 
   };


    //  deletePaymentAndWorkOrderPayment
    //  deletePaymentAndWorkOrderPayment(model) {
    //   // if (confirm('Are you sure you want to delete this payment entry?')) {
    //     this._demoService.deletePaymentAndWorkOrderPayment(model).subscribe(
    //       (data) => {
    //         this.work_order_deleted_data = data;
    //         let res = data[0];
    
    //               this.work_order_update_payment_model = {
    //                 work_order_id: model.invoice_id,
    //                 work_order_payment_total: null,
    //                 work_order_remaining_total: model.invoice_total,
    //                 work_order_status_id: 3, // approved
    //                 work_order_payment_status_id: 1, // outstanding
    //                 updated_by: this.sessionUserId,
    //               };
    //       },
    //       (err) => console.log(err.error),
    //      () => {
    //       this.updateWorkOrderAfterPaymentFigures(this.work_order_update_payment_model);

    //      }
    //     );
    //   // } // end confirm
    //   }



              //  deletePaymentAndInvoicePayment(model) {
              //   // if (confirm('Are you sure you want to delete this payment entry?')) {
              //     this._demoService.deletePaymentAndInvoicePayment(model).subscribe(
              //       (data) => {
              //         this.invoice_deleted_data = data;
              //         let res = data[0];
              
              //               this.invoice_update_payment_model = {
              //                 invoice_id: model.invoice_id,
              //                 invoice_payment_total: null,
              //                 invoice_remaining_total: model.invoice_total,
              //                 invoice_status_id: 3, // approved
              //                 invoice_payment_status_id: 1, // outstanding
              //                 updated_by: this.sessionUserId,
              //               };
              //       },
              //       (err) => console.log(err.error),
              //      () => {
              //       this.updateInvoiceAfterPaymentFigures(this.invoice_update_payment_model);
              //       // this.refreshSujectInvoicePage(this.subject_id);
              //      }
              //     );
              //   // } // end confirm
              //   }


              // this.getMyobAccountCodes();
              // this.getMyobAccountCodes();


// :: This Deletes the Record from Myob (Setup the rest.)
deleteMyobServiceWorkOrderPaymentModelStep2(model, workOrderUID) {
  // if (confirm('This will delete this Payment and updated Invoices in Myob, Are you Sure?')) {
this._demoService.deleteMyobSpendingPayment(model)
.pipe(
  retry(5), // you retry 3 times
  delay(1500) // each retry will start after 1 second,
)
.subscribe(
    data => { this.myobSpendingDeletedData = data;
      let res = data[0];

      // capture the SpendingUID
      const savedSpendingUID = model.UID; // set this so the local row versions can be updated.


           // I just need to loopk for row versisns for the Supplier Invoice Row versions
          //  this.lookupPurchaseUpdateWorkOrder2(savedSpendingUID , model);
            // now refresht eh work order and row version
            
            // this._WorkOrdersGridComponent.lookupWorkOrderUpdateInvoice(this.current_workOrderUID, model);
            // this.lookupPurchaseUpdateWorkOrder2(this.current_workOrderUID , model);



      model.myob_id = null;
      model.UID = null;
      model.sync_with_myob = null;
              // All Additional Myon Invoice Payment Variables
              model.UID = null;
              model.DepositTo = null;
              model.AccountUID = null;
              model.SupplierUID = null;
              model.URI = null;
              model.myob_array = null;
              model.RowVersion = null;
              model.myob_id = null;

                // this.lookupInvoiceUpdateInvoice2(inv_res.myob_id, data);
             // tslint:disable-next-line:max-line-length
            //  this.myobApi_ITW.lookupInvoiceUpdateInvoice2(invoiceUID, model); // having ussies finding the uncpuce UID on delete
            this.updateSpending(model); // update local payment model on work order (removed payment status)
            console.log('Work Order to Update: ' + model.UID); // payment UID
                            // Now Updatel invoice Paid.
                            // to get the invoice UID - lookup on load function from observable invoice_id
   // moved to below.?
  // tslint:disable-next-line:max-line-length
                    // tslint:disable-next-line:max-line-length
                    // this.myobApi_ITW.lookupInvoiceUpdateInvoice2(this.current_invoice_UID, model); // Get the invoice ID from the payment details array (had to lookup first!)]
                    // this needs to be the spending UID not the work order...
           //:: THIS NEEDS TO BE THE SPENDING ID OUT OF THE MODEL>
           console.log('res: ' + res.UID);  // WIROK ORDER OR SPENDING ID
           console.log('model: ' + model.UID);  // WIROK ORDER OR SPENDING ID
           console.log('model WOUID: ' + this.current_workOrderUID);  // WIROK ORDER OR SPENDING ID
           console.log('current_work_order_id: ' + this.current_work_order_id);  // WIROK ORDER OR SPENDING ID
           console.log('savedSpendingUID: ' + savedSpendingUID);  // WIROK ORDER OR SPENDING ID
         // this.lookupPurchaseUpdateWorkOrder2(this.current_work_order_id , model);
         this.lookupPurchaseUpdateWorkOrder2(this.current_workOrderUID , model);
         // Go to external module
          model.work_order_id = this.current_work_order_id; // needs to be set to make row versino updates to work remotely
          // this._WorkOrdersGridComponent.lookupWorkOrderUpdateInvoice(this.current_workOrderUID, model);

    },
    err => {
      // this.toastr.error('You need to login to MYOB again, Connection lost!');
     // console.error(err);
    },
    () => {
      // console.log('time to update row vers: ' + JSON.stringify(model));
      // this._WorkOrdersGridComponent.lookupWorkOrderUpdateInvoice(this.current_workOrderUID, model);
      // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
    } // redirects back to billing item page
    );
  // }; // end confirm
};






// lookupWorkOrderUpdateInvoice(UID, model){ // I copied from this model
lookupPurchaseUpdateWorkOrder2_______Copied(UID, model){
  this._demoService.getMyobPurchaseMapped(UID, model).subscribe(
    data4 => {
      console.log(data4);
     let resA = data4[0];
    // many
      // this.myobContactListMapped = data.data;
    // single
      this.myobInvoiceListMapped = data4;
    // Set the returned Variables Reququied for Update of a Myob Customer.
    console.log('UID: ' +  data4.UID);
    console.log('LastModified: ' + data4.LastModified);
    console.log('RowVersion: ' + data4.RowVersion);
    // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
    // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);


// work out the nulls for sub arraryas
let CategoryUID;
let OrderUID;
let SalespersonUID;

if (typeof model.Category === 'undefined' || model.Category === null ) {
  CategoryUID = null;
}else {
  CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
};
if (typeof model.Order === 'undefined' || model.Order === null ) {
  OrderUID = null;
}else {
  OrderUID = model.Category.UID; // can only call if actuall exist in the array!
};
if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
  SalespersonUID = null;
}else {
  SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
};

    this.set_RowVersion = data4.RowVersion;
    // model.IsIndividual = data4.IsIndividual;
    // model.SaleLayout = data4.SellingDetails.SaleLayout;
    // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
    // model.TaxCode = data4.SellingDetails.TaxCode.UID;
    // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
    // model.RowVersion = data4.RowVersion;
    // model.RowVersion = data4.RowVersion;


    console.log('Row Version data4: ' + data4.RowVersion);
    // console.log('Row Version resA: ' + resA.RowVersion);
    console.log('Row Version model: ' + model.RowVersion);
    console.log('Row Version model' + this.myobInvoiceListMapped.RowVersion );

    console.log('Data4 Model: ' + JSON.stringify(data4));

    model.RowVersion = data4.RowVersion; /// ????????????
    model.myob_array = JSON.stringify(data4);
    model.myob_id = UID;
    model.sync_with_myob = 1;

    // All Additional Myon Invoice Variables
    model = {
      ...model,
      ...data4 // returned results (Of Myob Insert)
    };

       // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
     const newArr = Object(data4.Lines).filter((ii) => (1 === 1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
     const  count_of_items = Object.keys(newArr).length;
       //  let res = data[0];
       // Run the job data queries.
       // need to do a loop of subject_billing items (.length)
       for (let i = 0; i < count_of_items; i++) {
         let res = newArr[i];

       // empty array of invoiceItemsList first
       this.invoiceItemsList = {};

         let TaxCodeUID;
         let JobUID;
         let AccountUID;
         let TaxCodeCode;

       console.log('TaxCodeUID:' +  res.TaxCode.UID);

       // check for nulls on sub arrays
       if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
       TaxCodeUID = null;
       TaxCodeCode = null;
       }else {
       TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
       TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
       };
       if (typeof res.Job === 'undefined' || res.Job === null ) {
       JobUID = null;
       }else {
       JobUID = res.Job.UID; // can only call if actuall exist in the array!
       };
       if (typeof res.Account === 'undefined' || res.Account === null ) {
       AccountUID = null;
       }else {
       AccountUID = res.Account.UID; // can only call if actuall exist in the array!
       };

       // so we can insert new items or remove ones that do not exist.
       // NEW
       this.work_orderItemsList = {
       RowID: res.RowID,
       Type: res.Type,
       Description: res.Description,
       UnitOfMeasure: res.UnitOfMeasure,
       UnitCount: res.UnitCount,
       UnitPrice: res.UnitPrice,
       UnitPriceForeign: res.UnitPriceForeign,
       DiscountPercent: res.DiscountPercent,
       Total: res.Total,
       TotalForeign: res.TotalForeign,
       AccountUID: AccountUID, // var
       JobUID: JobUID, // var
       TaxCodeUID: TaxCodeUID, // var
       TaxCodeCode: TaxCodeCode, // var
       RowVersion: res.RowVersion
             };

       console.log('workOrderItemsUpdateModel: ' + JSON.stringify(this.work_orderItemsList));
       // this.invoiceItemsList = this.invoiceItemsList;
       if (this.work_orderItemsList !== '{}') {
         // we udate each item in the loop that was just inserted.
       this.updateSubjectWorkOrderItem(this.work_orderItemsList, model.work_order_id);


       };
       } // End Lines Loop


      console.log('set model.work_order_id: ' + model.work_order_id);
      //  this.updateSubjectWorkOrder(model);  /// only run this if need to update teh entire record!... just need now versions
      // corrected upating the etire row instead of just row versions.
       this.updateWorkOrderAfterPaymentFigures(model);  // use this one in the work order payment widget compponent
       this.toastr.info('Work OrderVersions Upgraded');

    // this.refreshGrid();
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Collecting Work Order Myob Details');
   console.log(error.error);
  });
}; // end loopup and update function













/// THIS IS CUSTOM DESIGNED FOR THE DELETE FUNCTION
// Lookup Current Purchase and Update is detauls... Myob then local (Updates Version only. not all fields.)
// ## Update the work order and items with new details
lookupPurchaseUpdateWorkOrder2(UID, model){
  this._demoService.getMyobPurchaseMapped(UID, model).subscribe(
    data4 => {
     console.log(data4);
     let res = data4[0];
     this.myobSpendingListMapped = data4;
   // Set the returned Variables Reququied for Update of a Myob Customer.
  //  console.log('UID: ' +  data4.UID);
  console.log('UID: ' +  data4.UID);
  // console.log('retInvoiceModel: ' +  JSON.stringify(data4));

const sent_work_order_id = model.work_order_id;
//  const sent_real_invoice_id = model.invoice_id;

this.work_order_model = {}; // clear the invoice moddl.

// work out the nulls for sub arraryas
let CategoryUID;
let OrderUID;
let SalespersonUID

if (typeof model.Category === 'undefined' || model.Category === null ) {
  CategoryUID = null;
}else {
  CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
};
if (typeof model.Order === 'undefined' || model.Order === null ) {
  OrderUID = null;
}else {
  OrderUID = model.order.UID; // can only call if actuall exist in the array!
};
if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
  SalespersonUID = null;
}else {
  SalespersonUID = model.Salesperson.UID; // can only call if actuall exist in the array!
};

  this.set_RowVersion = data4.RowVersion;

// :: If this is a delete function - as was writtetn
this.work_order_delete_payment_model = {
  // work_order_id: model.work_order_id,
  work_order_payment_total: null,
  work_order_remaining_total: data4.TotalAmount,
  work_order_status_id: 3, // approved
  work_order_payment_status_id: 1, // outstanding
  updated_by: this.sessionUserId,
};


// make the function more universal? or make custom by itself?
   this.work_order_model = {
    //  ...data4,
    // ...this.myobSpendingListMapped, // Sin case I missed something.
    ...this.subject_work_order[0], // I aded this to see if it grabs the approapriate variabels needed for the update.
    myob_array: JSON.stringify(data4),
    myob_id: data4.UID,
    UID: data4.UID,
    Number: data4.Number,
    Date: data4.Date,
    SupplierInvoiceNumber: data4.SupplierInvoiceNumber,
    // CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
    SupplierUID: data4.Supplier.UID,
    SupplierName: data4.Supplier.Name,
    SupplierDisplayID: data4.Supplier.DisplayID,
    ShipToAddress: data4.ShipToAddress,
    PromisedDate: data4.PromisedDate,
    BalanceDueAmount: data4.BalanceDueAmount,
    BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
    Status: data4.Status,
    // TermsPaymentIsDue: data4.Terms.PaymentIsDue,
    TermsDiscountDate: data4.Terms.DiscountDate,
    TermsBalanceDueDate: data4.Terms.BalanceDueDate,
    TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
    TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
    TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
    TermsDiscount: data4.Terms.Discount,
    TermsDueDate: data4.Terms.DueDate,
    TermsFinanceCharge: data4.Terms.FinanceCharge,
    IsTaxInclusive: data4.IsTaxInclusive,
    Subtotal: data4.Subtotal,
    SubtotalForeign: data4.SubtotalForeign,
    Freight: data4.Freight,
    FreightForeign: data4.FreightForeign,
    FreightTaxCodeUID: data4.FreightTaxCode.UID,
    TotalTax: data4.TotalTax,
    TotalTaxForeign: data4.TotalTaxForeign,
    TotalAmount: data4.TotalAmount,
    TotalAmountForeign: data4.TotalAmountForeign,
    CategoryUID: CategoryUID, // var
    SalespersonUID: SalespersonUID, // var
    Comment: data4.Comment,
    ShippingMethod: data4.ShippingMethod,
    JournalMemo: data4.JournalMemo,
    ReferralSource: data4.ReferralSource,
    BillDeliveryStatus: data4.BillDeliveryStatus,
    AppliedToDate: data4.AppliedToDate,
    LastPaymentDate: data4.LastPaymentDate,
    AppliedToDateForeign: data4.AppliedToDateForeign,
    CanApplySurcharge: data4.CanApplySurcharge,
    OrderUID: OrderUID, // var
    OnlinePaymentMethod: data4.OnlinePaymentMethod,
    ForeignCurrencyUID: data4.ForeignCurrency,
    CurrencyExchangeRate: data4.CurrencyExchangeRate,
    LastModified: data4.LastModified,
    URI: data4.URI,
    RowVersion: data4.RowVersion,
    // invoice_id: data4.invoice_id // needed for update quiery.
    work_order_id: sent_work_order_id, // set manuall and test.
    ...this.work_order_delete_payment_model // this sets the correct paymetn status of the work order after delete.
   
    
          };

  //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
  //   // this.invoiceItemsList = this.invoiceItemsList;
  //   if (this.invoiceItemsList !== {}) {
  //     // we udate each item in the loop that was just inserted.
  //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
  //   };

  // this.toastr.info('collected new Work Order versions');
// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
// this.updateSubjectWorkOrderByUID(this.work_order_model);

// console.log('Upadte WO AfterPaymentModel: ' + JSON.stringify(model));
// console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
// this.updateWorkOrderAfterPaymentFigures(model); /// THIS BROKE THE ROW VERSIion pull BUTTON!
// this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions

// this.updateSubjectWorkOrderByUID(this.work_order_model); // original script. // this really shoudl work?

// create a lines model with all new data and upate existing invoice_items
// ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
  let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
  let  count_of_items = Object.keys(newArr).length;
  //  let res = data[0];
  // Run the job data queries.
  // need to do a loop of subject_billing items (.length)
  for(let i=0;i < count_of_items; i++) {
    let res = newArr[i];

  // empty array of invoiceItemsList first
  this.workOrderItemsList = {};

    let TaxCodeUID;
    let JobUID;
    let AccountUID;
    let TaxCodeCode;

// console.log('TaxCodeUID:' +  res.TaxCode.UID);

// check for nulls on sub arrays
if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
  TaxCodeUID = null;
  TaxCodeCode = null;
}else {
  TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
  TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
};
if (typeof res.Job === 'undefined' || res.Job === null ) {
  JobUID = null;
}else {
  JobUID = res.Job.UID; // can only call if actuall exist in the array!
};
if (typeof res.Account === 'undefined' || res.Account === null ) {
  AccountUID = null;
}else {
  AccountUID = res.Account.UID; // can only call if actuall exist in the array!
};

this.workOrderItemsList = {
  RowID: res.RowID,
  Type: res.Type,
  Description: res.Description,
  UnitOfMeasure: res.UnitOfMeasure,
  UnitCount: res.UnitCount,
  UnitPrice: res.UnitPrice,
  UnitPriceForeign: res.UnitPriceForeign,
  DiscountPercent: res.DiscountPercent,
  Total: res.Total,
  TotalForeign: res.TotalForeign,
  AccountUID: AccountUID, // var
  JobUID: JobUID, // var
  TaxCodeUID: TaxCodeUID, // var
  TaxCodeCode: TaxCodeCode, // var
  RowVersion: res.RowVersion
        };
  
  // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
  // this.invoiceItemsList = this.invoiceItemsList;
  if (this.workOrderItemsList !== '{}') {
  this.updateSubjectWorkOrderItem(this.workOrderItemsList, this.work_order_model.work_order_id);
  };
  } // End Lines Loop


  // just need to update the versions for this function of the work order

this.toastr.info('Work Order Vrs Updated In SOP');

   // now finally update the invoice
  //  this.updateSubjectInvoice(model);
      // this.refreshGrid();
      // this.gfunc.globalJobSubjectCostViewSkipRoute(this.subject_id);
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Collecting Purchase Myob Details');
   console.log(error.error);
  },
  () => {
    // console.log('UPDATE work_order_model: ' + JSON.stringify(this.work_order_model));
    this.updateSubjectWorkOrder(this.work_order_model);  /// only run this if need to update teh entire record!... just need now versions
  }
  );
}; // end loopup and update function




updateSubjectWorkOrder(work_order_model){
  this._demoService.updateSubjectWorkOrder(work_order_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
  this.toastr.success('Local SupplierPruchase/WO Updated');
     return true;
    },
    error => {
      console.log(error.error);
    this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
);
 }



updateSubjectWorkOrderByUID(work_orer_model){
  this._demoService.updateSubjectWorkOrderByUID(work_orer_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
  this.toastr.success('Local Work Updated');
     return true;
    },
    error => {
      console.log(error.error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }


 updateSubjectWorkOrderItem(model, work_order_id){
  this._demoService.updateSubjectWorkOrderItemByDescription(model, work_order_id).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
    //  return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
);
 }


    // // Lookup YUpdate Function
    // lookupInvoiceUpdateInvoice2(UID, model){
    // this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
    // data4 => {
    //  console.log(data4);
    //  let res = data4[0];
    //  this.myobInvoiceListMapped = data4;
    // // Set the returned Variables Reququied for Update of a Myob Customer.
    // //  console.log('UID: ' +  data4.UID);
    // console.log('UID: ' +  data4.UID);
    // // console.log('retInvoiceModel: ' +  JSON.stringify(data4));

    // const sent_invoice_id = UID;
    // //  const sent_real_invoice_id = model.invoice_id;


    // // this.invoice_model = {}; // clear the invoice moddl.

    // // work out the nulls for sub arraryas
    // let CategoryUID;
    // let OrderUID;
    // let SalespersonUID

    // if (typeof model.Category === 'undefined' || model.Category === null ) {
    // CategoryUID = null;
    // }else {
    // CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
    // };
    // if (typeof model.Order === 'undefined' || model.Order === null ) {
    // OrderUID = null;
    // }else {
    // OrderUID = model.Category.UID; // can only call if actuall exist in the array!
    // };
    // if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    // SalespersonUID = null;
    // }else {
    // SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
    // };



    // this.set_RowVersion = data4.RowVersion;
    // // Local data vars.
    // //  model.myob_array = JSON.stringify(data4);
    // //  model.myob_id = data4.UID;

    // //  model.UID = data4.UID;
    // //  model.Number = data4.Number;
    // //  model.Date = data4.Date;
    // //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
    // //  model.CustomerUID = data4.Customer.UID;
    // //  model.CustomerName = data4.Customer.Name;
    // //  model.CustomerDisplayID = data4.Customer.DisplayID;
    // //  model.PromisedDate = data4.PromisedDate;
    // //  model.BalanceDueAmount = data4.BalanceDueAmount;
    // //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
    // //  model.Status = data4.Status;
    // //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
    // //  model.TermsDiscountDate = data4.Terms.DiscountDate;
    // //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
    // //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
    // //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
    // //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
    // //  model.TermsDiscount = data4.Terms.Discount;
    // //  model.TermsDueDate = data4.Terms.DueDate;
    // //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
    // //  model.IsTaxInclusive = data4.IsTaxInclusive;
    // //  model.Subtotal = data4.Subtotal;
    // //  model.SubtotalForeign = data4.SubtotalForeign;
    // //  model.Freight = data4.Freight;
    // //  model.FreightForeign = data4.FreightForeign;
    // //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
    // //  model.TotalTax = data4.TotalTax;
    // //  model.TotalTaxForeign = data4.TotalTaxForeign;
    // //  model.TotalAmount = data4.TotalAmount;
    // //  model.TotalAmountForeign = data4.TotalAmountForeign;
    // //  model.CategoryUID = CategoryUID; // var
    // //  model.SalespersonUID = SalespersonUID; // var
    // //  model.Comment = data4.Comment;
    // //  model.ShippingMethod = data4.ShippingMethod;
    // //  model.JournalMemo = data4.JournalMemo;
    // //  model.ReferralSource = data4.ReferralSource;
    // //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
    // //  model.LastPaymentDate = data4.LastPaymentDate;
    // //  model.CanApplySurcharge = data4.CanApplySurcharge;
    // //  model.OrderUID = OrderUID; // var
    // //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
    // //  model.ForeignCurrency = data4.ForeignCurrency;
    // //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
    // //  model.LastModified = data4.LastModified;
    // //  model.URI = data4.URI;
    // //  model.RowVersion = data4.RowVersion;



    // // make the function more universal? or make custom by itself?
    // this.invoice_model = {
    // myob_array: JSON.stringify(data4),
    // myob_id: data4.UID,
    // UID: data4.UID,
    // Number: data4.Number,
    // Date: data4.Date,
    // CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
    // CustomerUID: data4.Customer.UID,
    // CustomerName: data4.Customer.Name,
    // CustomerDisplayID: data4.Customer.DisplayID,
    // PromisedDate: data4.PromisedDate,
    // BalanceDueAmount: data4.BalanceDueAmount,
    // BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
    // Status: data4.Status,
    // TermsPaymentIsDue: data4.Terms.PaymentIsDue,
    // TermsDiscountDate: data4.Terms.DiscountDate,
    // TermsBalanceDueDate: data4.Terms.BalanceDueDate,
    // TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
    // TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
    // TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
    // TermsDiscount: data4.Terms.Discount,
    // TermsDueDate: data4.Terms.DueDate,
    // TermsFinanceCharge: data4.Terms.FinanceCharge,
    // IsTaxInclusive: data4.IsTaxInclusive,
    // Subtotal: data4.Subtotal,
    // SubtotalForeign: data4.SubtotalForeign,
    // Freight: data4.Freight,
    // FreightForeign: data4.FreightForeign,
    // FreightTaxCodeUID: data4.FreightTaxCode.UID,
    // TotalTax: data4.TotalTax,
    // TotalTaxForeign: data4.TotalTaxForeign,
    // TotalAmount: data4.TotalAmount,
    // TotalAmountForeign: data4.TotalAmountForeign,
    // CategoryUID: CategoryUID, // var
    // SalespersonUID: SalespersonUID, // var
    // Comment: data4.Comment,
    // ShippingMethod: data4.ShippingMethod,
    // JournalMemo: data4.JournalMemo,
    // ReferralSource: data4.ReferralSource,
    // InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
    // LastPaymentDate: data4.LastPaymentDate,
    // CanApplySurcharge: data4.CanApplySurcharge,
    // OrderUID: OrderUID, // var
    // OnlinePaymentMethod: data4.OnlinePaymentMethod,
    // ForeignCurrency: data4.ForeignCurrency,
    // CurrencyExchangeRate: data4.CurrencyExchangeRate,
    // LastModified: data4.LastModified,
    // URI: data4.URI,
    // RowVersion: data4.RowVersion,
    // // invoice_id: data4.invoice_id // needed for update quiery.
    // invoice_id: sent_invoice_id // set manuall and test.
    //       };

    // //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // //   // this.invoiceItemsList = this.invoiceItemsList;
    // //   if (this.invoiceItemsList !== {}) {
    // //     // we udate each item in the loop that was just inserted.
    // //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    // //   };


    // // this.invoice_model = this.invoice_model;
    // // this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
    // this.updateSubjectInvoiceByUID(this.invoice_model);

    // // create a lines model with all new data and upate existing invoice_items
    // // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    // let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    // let  count_of_items = Object.keys(newArr).length;
    // //  let res = data[0];
    // // Run the job data queries.
    // // need to do a loop of subject_billing items (.length)
    // for(let i=0;i < count_of_items; i++) {
    // let res = newArr[i];

    // // empty array of invoiceItemsList first
    // this.invoiceItemsList = {};

    // let TaxCodeUID;
    // let JobUID;
    // let AccountUID;
    // let TaxCodeCode;

    // // console.log('TaxCodeUID:' +  res.TaxCode.UID);

    // // check for nulls on sub arrays
    // if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    // TaxCodeUID = null;
    // TaxCodeCode = null;
    // }else {
    // TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    // TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
    // };
    // if (typeof res.Job === 'undefined' || res.Job === null ) {
    // JobUID = null;
    // }else {
    // JobUID = res.Job.UID; // can only call if actuall exist in the array!
    // };
    // if (typeof res.Account === 'undefined' || res.Account === null ) {
    // AccountUID = null;
    // }else {
    // AccountUID = res.Account.UID; // can only call if actuall exist in the array!
    // };

    // this.invoiceItemsList = {
    // RowID: res.RowID,
    // Type: res.Type,
    // Description: res.Description,
    // UnitOfMeasure: res.UnitOfMeasure,
    // UnitCount: res.UnitCount,
    // UnitPrice: res.UnitPrice,
    // UnitPriceForeign: res.UnitPriceForeign,
    // DiscountPercent: res.DiscountPercent,
    // Total: res.Total,
    // TotalForeign: res.TotalForeign,
    // AccountUID: AccountUID, // var
    // JobUID: JobUID, // var
    // TaxCodeUID: TaxCodeUID, // var
    // TaxCodeCode: TaxCodeCode, // var
    // RowVersion: res.RowVersion
    //     };

    // // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // // this.invoiceItemsList = this.invoiceItemsList;
    // if (this.invoiceItemsList !== {}) {
    // this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
    // };
    // } // End Lines Loop


    // this.toastr.info('Invoice Vrs Updated In SOP');
    // // now finally update the invoice
    // //  this.updateSubjectInvoice(model);
    //   // this.refreshGrid();
    // },
    // error => {
    // // console.error('Error saving Event!');
    // this.toastr.error('Error Collecting Invoice Myob Details');
    // console.log(error.error);
    // });
    // }; // end loopup and update function





}
